export default "__VITE_ASSET__CAD4VhwQ__"